import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { getLocalParticipant, getRemoteParticipants } from '../../../base/participants/functions';
import { useStressPolling } from '../../hooks/useStressPolling';
import { mapApiDataToParticipantStress, getParticipantStressCategory } from '../../utils/stressDataMapper';
import './stress-check-panel.css';
// ストレスレベルに応じた絵文字を定義
const STRESS_ICONS = {
    low: '😊',
    medium: '😐',
    high: '😰',
    veryHigh: '😱',
    unknown: '❓'
};
/**
 * Implements the stress check panel.
 */
function StressCheckPanel(props) {
    const { _visible, _localParticipant, _remoteParticipants, _stressData, _isPolling, _lastUpdated, _error } = props;
    // Initialize polling hook
    useStressPolling();
    if (!_visible) {
        return null;
    }
    // Map stress data to participant stress
    const stressMap = mapApiDataToParticipantStress(_stressData);
    // 全参加者のリストを作成
    const allParticipants = _localParticipant
        ? [_localParticipant, ..._remoteParticipants]
        : _remoteParticipants;
    return (React.createElement("div", { className: 'stress-check-panel' },
        React.createElement("div", { className: 'stress-check-header' },
            React.createElement("h3", null, "\u30B9\u30C8\u30EC\u30B9\u30C1\u30A7\u30C3\u30AF"),
            _isPolling && React.createElement("div", { className: 'polling-indicator' }, "\uD83D\uDD04 \u66F4\u65B0\u4E2D..."),
            _error && React.createElement("div", { className: 'error-indicator' },
                "\u274C \u30A8\u30E9\u30FC: ",
                _error),
            _lastUpdated && (React.createElement("div", { className: 'last-updated' },
                "\u6700\u7D42\u66F4\u65B0: ",
                new Date(_lastUpdated).toLocaleTimeString()))),
        React.createElement("div", { className: 'stress-check-list' }, allParticipants.map(participant => {
            const stressCategory = getParticipantStressCategory(stressMap, participant.id);
            return (React.createElement("div", { key: participant.id, className: 'stress-check-item' },
                React.createElement("span", { className: 'participant-name' },
                    participant.name || 'Anonymous',
                    participant.local && ' (You)'),
                React.createElement("span", { className: 'stress-icon' }, STRESS_ICONS[stressCategory])));
        })),
        React.createElement("div", { className: 'stress-check-legend' },
            React.createElement("h4", null, "\u30B9\u30C8\u30EC\u30B9\u30EC\u30D9\u30EB"),
            React.createElement("div", { className: 'legend-items' },
                React.createElement("div", { className: 'legend-item' },
                    React.createElement("span", { className: 'legend-icon' }, STRESS_ICONS.low),
                    React.createElement("span", { className: 'legend-label' }, "\u4F4E\u3044")),
                React.createElement("div", { className: 'legend-item' },
                    React.createElement("span", { className: 'legend-icon' }, STRESS_ICONS.medium),
                    React.createElement("span", { className: 'legend-label' }, "\u666E\u901A")),
                React.createElement("div", { className: 'legend-item' },
                    React.createElement("span", { className: 'legend-icon' }, STRESS_ICONS.high),
                    React.createElement("span", { className: 'legend-label' }, "\u9AD8\u3044")),
                React.createElement("div", { className: 'legend-item' },
                    React.createElement("span", { className: 'legend-icon' }, STRESS_ICONS.veryHigh),
                    React.createElement("span", { className: 'legend-label' }, "\u975E\u5E38\u306B\u9AD8\u3044"))))));
}
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code StressCheckPanel} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const localParticipant = getLocalParticipant(state);
    const remoteParticipants = getRemoteParticipants(state);
    const stressCheckState = state['features/stress-check'];
    return {
        _visible: stressCheckState?.visible || false,
        _localParticipant: localParticipant,
        _remoteParticipants: Array.from(remoteParticipants.values()),
        _stressData: stressCheckState?.stressData || [],
        _isPolling: stressCheckState?.polling || false,
        _lastUpdated: stressCheckState?.lastUpdated || null,
        _error: stressCheckState?.error || null
    };
}
export default translate(connect(_mapStateToProps)(StressCheckPanel));
